import { trackEvent, identifyUser } from './utils';

const segmentFormTracking = () => {
  /**
   * Get form data from fields.
   * Only adds truthy values to returned data.
   *
   * @param {HTMLElement} form Form element
   * @param {Array} inputs Array of fields: [ { id, field } ]
   *
   * @returns {Object} { id: 'field value' }
   */
  const getFormData = (form, fields) =>
    fields.reduce((prev, current) => {
      const fieldValue = form.querySelector(current.input)?.value;

      return {
        ...prev,
        ...(fieldValue && { [current.id]: fieldValue }),
      };
    }, {});

  /**
   * Initialize form tracking.
   *
   * @param {HTMLElement} form Form element
   * @param {Object} Options - The options.
   */
  const init = (
    formSelector,
    {
      formFields,
      extraData = {},
      eventName = 'form_submitted',
      indentifyOnEmail = true,
      debug = false,
    } = {},
  ) => {
    if (!formSelector || !formFields) {
      return;
    }

    formSelector.addEventListener('submit', () => {
      const eventData = {
        ...getFormData(formSelector, formFields),
        ...extraData,
      };

      trackEvent(eventName, eventData);

      if (debug) {
        // eslint-disable-next-line
        console.log('SUMBIT DATA:', eventName, eventData);
      }

      // Update the segmemt user ID with email, if present.
      if (indentifyOnEmail && eventData.email) {
        const identifyData = {
          email: eventData.email,
          user_type: localStorage.getItem('version'),
          ...(eventData.first_name && { first_name: eventData.first_name }),
          ...(eventData.last_name && { last_name: eventData.last_name }),
        };

        identifyUser(eventData.email, identifyData);

        if (debug) {
          // eslint-disable-next-line
          console.log('IDENTIFY DATA:', eventData.email, identifyData);
        }
      }
    });
  };

  return { init };
};

export default segmentFormTracking;
